import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/phoneexpert',
    name: '绑定手机号',
    component: () => import(/* webpackChunkName: "wx_index" */ '../views/expert/BindPhone.vue')
  },
  {
    path: '/phoneorganization',
    name: '注册',
    component: () => import(/* webpackChunkName: "wx_index" */ '../views/organization/BindPhone.vue')
  },
  {
    path: '/phone',
    name: '绑定手机号',
    component: () => import(/* webpackChunkName: "wx_index" */ '../views/BindPhone.vue')
  },
  {
    path: '/expert',
    component: () => import(/* webpackChunkName: "wx_index" */ '../views/expert/ExpertSpace.vue'),
    children: [
      {
        path: '/expert/user',
        name: '完善信息',
        component: () => import(/* webpackChunkName: "wx_index" */ '../views/expert/ExpertInfo.vue')
      },
      {
        path: '/expert/',
        name: '个人中心',
        component: () => import(/* webpackChunkName: "wx_index" */ '../views/expert/Home.vue')
      },
      {
        path: '/expert/qrcode',
        name: '专属二维码',
        component: () => import(/* webpackChunkName: "wx_index" */ '../views/expert/Qrcode.vue')
      },
      {
        path: '/expert/list',
        name: '我的客户',
        component: () => import(/* webpackChunkName: "wx_index" */ '../views/expert/UserList.vue')
      },
      {
        path: '/expert/visit',
        name: '检验报告',
        component: () => import(/* webpackChunkName: "wx_index" */ '../views/VisitsChart.vue')
      },
    ],
  },
  {
    path: '/organization',
    component: () => import(/* webpackChunkName: "wx_index" */ '../views/organization/OrganizationSpace.vue'),
    children: [
      {
        path: '/organization/',
        name: '我的机构',
        component: () => import(/* webpackChunkName: "wx_index" */ '../views/organization/Home.vue')
      },
      {
        path: '/organization/list',
        name: '我的客户',
        component: () => import(/* webpackChunkName: "wx_index" */ '../views/expert/UserList.vue')
      },
      {
        path: '/organization/users',
        name: '专业人员',
        component: () => import(/* webpackChunkName: "wx_index" */ '../views/organization/ExpertList.vue')
      },
      {
        path: '/organization/user',
        name: '更新信息',
        component: () => import(/* webpackChunkName: "wx_index" */ '../views/organization/OrganizationInfo.vue')
      },
      {
        path: '/organization/visit',
        name: '检验报告',
        component: () => import(/* webpackChunkName: "wx_index" */ '../views/VisitsChart.vue')
      },
    ],
  },
  {
    path: '/',
    component: () => import(/* webpackChunkName: "wx_index" */ '../views/NormalSpace.vue'),
    children: [

      {
        path: '/',
        name: '个人中心',
        component: () => import(/* webpackChunkName: "wx_index" */ '../views/Home.vue')
      },
      {
        path: '/adduser',
        name: '就诊人信息',
        component: () => import(/* webpackChunkName: "wx_index" */ '../views/AddUser.vue')
      },
      {
        path: '/visit',
        name: '录入验眼数据',
        component: () => import(/* webpackChunkName: "wx_index" */ '../views/Visit.vue')
      },
      {
        path: '/visits',
        name: '检测列表',
        component: () => import(/* webpackChunkName: "wx_index" */ '../views/VisitsList.vue')
      },
      {
        path: '/visitschart',
        name: '检测列表',
        component: () => import(/* webpackChunkName: "wx_index" */ '../views/VisitsChart.vue')
      },
    ]
  },
]
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  if (to.name) {
    document.title = to.name
  }
  next()
})
export default router
